import logo from './logo.png';
import heroimg1 from './fractile.webp';
import whitelogo from './whitelogo.png';
import linkedin from './linkedin.svg';
import homeabout from './home_about-1.webp';
import vector from './Vector.png';
import aboutimg from './about/aboutimg.webp';
import aboutimg1 from './about-img-1.png';
import mobileaboutimg1 from './mobile-about-img-1.png';
import constructionimg from './construction.webp';
import ourMissionimg1 from './about/ourMission1.webp';
import challangesecimage from './about/challangessec1.webp';
import ourVision from './about/ourVision.webp';
import companyImg1 from './company/companyimg.png';
import companyImg2 from './company/companyimg1.png';
import companyImg3 from './company/comapnyimg2.png';
import teammember1 from './team/teamPhoto/team1.webp';
import teammember2 from './team/teamPhoto/team2.webp';
import teammember3 from './team/teamPhoto/team3.webp';
import teammember4 from './team/teamPhoto/team4.webp';
import teammember5 from './team/teamPhoto/team5.webp';
import teammember6 from './team/teamPhoto/team6.webp';
import teammember7 from './team/teamPhoto/team7.webp';
import teammember8 from './team/teamPhoto/team8.png';
import teammember9 from './team/teamPhoto/team9.webp';
import teammember10 from './team/teamPhoto/team10.png';
import sliderteam1 from './team/teamPhoto/teamslider1.png';
import sliderteam2 from './team/teamPhoto/teamslider2.png';
import sliderteam5 from './team/teamPhoto/teamslider5.png';
import sliderteam6 from './team/teamPhoto/teamslider6.png';
import sliderteam7 from './team/teamPhoto/teamslider7.png';
import sliderteam9 from './team/teamPhoto/teamslider9.png';
import sliderteam10 from './team/teamPhoto/teamslider10.png';       
import footerbg from './footer-bg.webp';
import sliderElement1 from './slider-element-1.webp';
import sliderElement2 from './slider-element-2.webp';
import sliderElement3 from './slider3-element-1.webp';
import sliderElement4 from './slider3-element-2.webp';
import building1 from './Part1.png';
import building2 from './Part2.png';
import building3 from './Part3.png';
import twodto3d from './company/2dtosupplemental3dmodeling.png';
import twodto3d2 from './company/2dtosupplemental3dmodeling2.png';
import twodto3d3 from './company/2dtosupplemental3dmodeling3.png';
import threedwalkthrough from './services/3dwalkthrough.png';
import threedwalkthrough2 from './services/3dwalkthrough2.png';
import threedwalkthrough3 from './services/3dwalkthrough3.png';
import fourdstilulation from './company/4dsimulation.png';
import fourdstilulation2 from './company/4dsimulation2.png';
import fourdstilulation3 from './company/4dsimulation3.png';
import BIMStimulation from './services/BIM-execution.webp';
import BIMStimulation2 from './services/BIM-execution2.webp';
import ClashDetection from './services/clashdecetion.webp';
import ClashDetection2 from './services/clashdecetion2.webp';
import supplimental from './company/supplementalmodeling.png';
import supplimental2 from './company/supplementalmodeling2.png';
import supplimental3 from './company/supplementalmodeling3.png';
import BIMexecution from './services/BIM-execution.webp';
import BIMexecution2 from './services/BIM-execution2.webp';
import poinntcloudto3d from './services/pointcloudto3d.webp';
import poinntcloudto3d2 from './services/pointcloudto3d2.webp';
import shpdrawing from './services/shopdrawing.webp';
import shpdrawing2 from './services/shopdrawing2.webp';
import overlay2d from './services/2doverlay.webp';
import overlay2d2 from './services/2doverlay2.webp';
import pmsoftware from './services/pmsoftware.webp';
import pmsoftware2 from './services/pmsoftware2.webp';
import render2dn3d from './company/2dn3drender.png';
import render2dn3d2 from './company/2dn3drender2.png';
import render2dn3d3 from './company/2dn3drender3.png';
import popupbgprop from './team/popupbgimg.png';
import whatwedo from './what-we-do.png';
import industryExperts from './industry-experts.png';
import cuttingEdgeTech from './cutting-edge-tech.png';
import seamlessCollab from './seamleass-collab.png';
import customSol from './custom-solution.png';
import caseStudies1 from './cs1.png';
import caseStudies2 from './cs2.png';
import caseStudies3 from './cs3.png';
import caseStudies4 from './cs4.png';
import caseStudies5 from './cs5.png';
import caseStudies6 from './cs6.png';
import educationSectorImg from './education-sector.png';
import constructiomsector from './construction-sector.png';
import healthcaresector from './healthcare-sector.png';
import hospitalitysector from './hospitality-sector.png';
import fbicon from './fb.png';
import instaicon from './insta.png';
import xicon from './x.png'
import linkedincon from './linkedin.png';

import logo1 from './Fractile-Logos/logo1.png';
import logo2 from './Fractile-Logos/logo2.png';
import logo3 from './Fractile-Logos/logo3.png';
import logo4 from './Fractile-Logos/logo4.png';
import logo5 from './Fractile-Logos/logo5.png';
import logo6 from './Fractile-Logos/logo6.png';
import servicesBanner from './services/servicesbg.png';

// case study

// John hopkins
import casestudybanner1 from './casestudy/cs1banner.png';
import cs1img1 from './casestudy/cs1img1.png';
import cs1img2 from './casestudy/cs1img2.png';
import cs1img3 from './casestudy/cs1img3.png';
import cs1bottom from './casestudy/csbottomimg.png';

//NIH SRLM
import casestudybanner2 from './casestudy/cs1banner.png';
import cs2img1 from './casestudy/cs2img1.png';
import cs2img2 from './casestudy/cs2img2.png';
import cs2img3 from './casestudy/cs2img3.png';
import cs2bottom from './casestudy/cs2bottom.png';

//Inova Hospita;
import casestudybanner3 from './casestudy/cs1banner.png';
import cs3img1 from './casestudy/cs3img1.png';
import cs3img2 from './casestudy/cs3img2.png';
import cs3img3 from './casestudy/cs3img3.png';
import cs3bottom from './casestudy/cs3bottom.png';

//Montgomery clg
import casestudybanner4 from './casestudy/cs1banner.png';
import cs4img1 from './casestudy/cs4img1.png';
import cs4img2 from './casestudy/cs4img2.png';
import cs4img3 from './casestudy/cs4img3.png';
import cs4bottom from './casestudy/cs4bottomimg.png';

//Park Metro
import casestudybanner5 from './casestudy/cs1banner.png';
import cs5img1 from './casestudy/cs5img1.png';
import cs5img2 from './casestudy/cs5img2.png';
import cs5img3 from './casestudy/cs5img3.png';
import cs5bottom from './casestudy/cs5bottom.png';

//O'hare airport
import casestudybanner6 from './casestudy/cs1banner.png';
import cs6img1 from './casestudy/cs6img1.png';
import cs6img2 from './casestudy/cs6img2.png';
import cs6img3 from './casestudy/cs6img3.png';
import cs6bottom from './casestudy/cs6bottomimg.png'

//IAD
import casestudybanner7 from './casestudy/cs1banner.png';
import cs7img1 from './casestudy/cs7img1.png';
import cs7img2 from './casestudy/cs7img2.png';
import cs7img3 from './casestudy/cs7img3.png';
import cs7bottom from './casestudy/cs7bottom.png';



export const image={
    constructionimg,
    building1,
    building2,
    building3,
    whatwedo,
    industryExperts,
    cuttingEdgeTech,
    seamlessCollab,
    customSol,
    sliderElement3,
    sliderElement4,
    sliderElement1,
    sliderElement2,
    footerbg,
    teammember1,
    teammember2,
    teammember3,
    teammember4,
    teammember5,
    teammember6,
    teammember7,
    teammember8,
    teammember9,
    teammember10,
    sliderteam1,
    sliderteam2,
    sliderteam5,
    sliderteam6,
    sliderteam7,
    sliderteam9,
    sliderteam10,
    // teammember11,
    companyImg1,
    companyImg2,
    companyImg3,
    ourVision,
    challangesecimage,
    ourMissionimg1,
    aboutimg,
    aboutimg1,
    mobileaboutimg1,
    logo,
    heroimg1,
    whitelogo,
    linkedin,
    homeabout,  
    vector,  
    twodto3d,
    twodto3d2,
    twodto3d3,
    threedwalkthrough,
    threedwalkthrough2,
    threedwalkthrough3,
    fourdstilulation,
    fourdstilulation2,
    fourdstilulation3,
    BIMStimulation,
    BIMStimulation2,
    ClashDetection,
    ClashDetection2,
    supplimental,
    supplimental2,
    supplimental3,
    BIMexecution,
    BIMexecution2,
    poinntcloudto3d,
    poinntcloudto3d2,
    shpdrawing,
    shpdrawing2,
    overlay2d,
    overlay2d2,
    pmsoftware,
    pmsoftware2,
    render2dn3d,
    render2dn3d2,
    render2dn3d3,
    popupbgprop,
    caseStudies1,
    caseStudies2,
    caseStudies3,
    caseStudies4,
    caseStudies5,
    caseStudies6,
    educationSectorImg,
    constructiomsector,
    healthcaresector,
    hospitalitysector,
    fbicon,
    instaicon,
    xicon,
    linkedincon,
    logo1,
    logo2,
    logo3,
    logo4,
    logo5,
    logo6,
    servicesBanner,
    
    casestudybanner1,
    cs1img1,
    cs1img2,
    cs1img3,
    cs1bottom,

    casestudybanner2,
    cs2img1,
    cs2img2,
    cs2img3, 
    cs2bottom,

    casestudybanner3,
    cs3img1,
    cs3img2,
    cs3img3, 
    cs3bottom,

    casestudybanner4,
    cs4img1,
    cs4img2,
    cs4img3, 
    cs4bottom,

    casestudybanner5,
    cs5img1,
    cs5img2,
    cs5img3, 
    cs5bottom,

    casestudybanner6,
    cs6img1,
    cs6img2,
    cs6img3, 
    cs6bottom,

    casestudybanner7,
    cs7img1,
    cs7img2,
    cs7img3,
    cs7bottom,
}